/**
 * Exports all models so they can be used as:
 * 
 *  import { SomeModel } from '@/models'
 * 
 * MAZ - 12-abr-2020
 */
import { Account } from './accounts'
import { Connector } from './connectors'
import { RecordDef, is, isVisibleType } from './record-defs'
import { ReportDef } from './report-defs'
import { Session } from './sessions'
import { User } from './users'

const NULLUID = '0000-0000-0000-0000';

export { 
  NULLUID,
  Account, 
  Connector,
  User,
  Session,
  RecordDef, is, isVisibleType,
  ReportDef
}
